module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.ac21cac.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-regular-400.woff2
// module id = 337
// module chunks = 1